import React from 'react'
import { Dots } from '../lib/dots'
import { CircularProgress } from '@mui/material'

function SuspenseLoader() {
    return (
        <section className='ad_pg ad_bg d-flex flex-column justify-content-center align-items-center' style={{ height: "100vh" }}>
            <CircularProgress size={50} />
            <Dots>Loading</Dots>
        </section>
    )
}

export default SuspenseLoader